var map = {
	"./acsi.json": 1490,
	"./de-de.json": 1491,
	"./en-us.json": 640,
	"./id.json": 1492,
	"./ja.json": 1493,
	"./ko.json": 1494,
	"./vi.json": 1495,
	"./whitelists/whitelist_acsi.json": 1496,
	"./whitelists/whitelist_de-de.json": 1497,
	"./whitelists/whitelist_en-us.json": 1498,
	"./whitelists/whitelist_en.json": 1499,
	"./whitelists/whitelist_id.json": 1500,
	"./whitelists/whitelist_ja.json": 1501,
	"./whitelists/whitelist_ko.json": 1502,
	"./whitelists/whitelist_vi.json": 1503,
	"./whitelists/whitelist_zh-cn.json": 1504,
	"./whitelists/whitelist_zh-tw.json": 1505,
	"./zh-cn.json": 1506,
	"./zh-tw.json": 1507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1489;